import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMotionWarning = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: 81.374,
	height: 57.682,
	viewBox: "0 0 81.374 57.682",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip-path",
		children: /* @__PURE__ */ _jsx("rect", {
			id: "Rectangle_1996",
			"data-name": "Rectangle 1996",
			width: 81.374,
			height: 57.682,
			fill: "#fff"
		})
	}) }), /* @__PURE__ */ _jsx("g", {
		id: "Group_6059",
		"data-name": "Group 6059",
		transform: "translate(0 0)",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "Group_6058",
			"data-name": "Group 6058",
			transform: "translate(0 0)",
			clipPath: "url(#clip-path)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					id: "Path_8883",
					"data-name": "Path 8883",
					d: "M24.274,49.667A7.1,7.1,0,0,1,18.12,39.042L38.457,3.566A7.023,7.023,0,0,1,44.591,0h.023a7.024,7.024,0,0,1,6.134,3.529L71.3,38.88a7.1,7.1,0,0,1-6.112,10.663L24.3,49.667ZM44.613,2.119H44.6a4.925,4.925,0,0,0-4.3,2.5L19.957,40.1a4.977,4.977,0,0,0,4.318,7.452h.016l40.891-.125a4.977,4.977,0,0,0,4.287-7.478L48.916,4.594a4.927,4.927,0,0,0-4.3-2.475",
					transform: "translate(-5.042 0)",
					fill: "#fff"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_8884",
					"data-name": "Path 8884",
					d: "M52.016,45.191a2.621,2.621,0,0,1,2.724-2.627,2.584,2.584,0,0,1,2.694,2.589,2.611,2.611,0,0,1-2.656,2.661,2.647,2.647,0,0,1-2.761-2.623m.087-21.3,5.011-.035L56.38,39.709l-3.353.024Z",
					transform: "translate(-15.276 -7.006)",
					fill: "#fff"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_8885",
					"data-name": "Path 8885",
					d: "M15.646,73.2a4.149,4.149,0,0,1-.918-.321A13.98,13.98,0,0,1,12.4,71.6,15.452,15.452,0,0,1,5.727,56.315a14,14,0,0,1,.646-2.575,4.154,4.154,0,0,1,.388-.891,28.507,28.507,0,0,0-.777,3.5,15.8,15.8,0,0,0,6.564,15.037,28.488,28.488,0,0,0,3.1,1.812",
					transform: "translate(-1.627 -15.521)",
					fill: "#fff"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_8886",
					"data-name": "Path 8886",
					d: "M5.3,74.8c-.017.019-.184-.109-.473-.359A10.855,10.855,0,0,1,3.691,73.29,15.418,15.418,0,0,1,0,63.473,10.842,10.842,0,0,1,.092,61.86a1.865,1.865,0,0,1,.119-.581c.065.006-.021.843.049,2.186a17.086,17.086,0,0,0,3.632,9.66c.833,1.057,1.449,1.629,1.4,1.677",
					transform: "translate(0 -17.997)",
					fill: "#fff"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_8887",
					"data-name": "Path 8887",
					d: "M106.371,45.6a3.458,3.458,0,0,1,.268.772,7.413,7.413,0,0,1,.23.93,12.27,12.27,0,0,1,.215,1.253,18.2,18.2,0,0,1,.132,3.308,19.141,19.141,0,0,1-2.106,7.789,18.092,18.092,0,0,1-1.781,2.791,12.312,12.312,0,0,1-.817.974,7.352,7.352,0,0,1-.667.687,3.482,3.482,0,0,1-.62.532c-.053-.052.8-.844,1.9-2.349a20.043,20.043,0,0,0,1.687-2.789,20.161,20.161,0,0,0,2.07-7.656,20,20,0,0,0-.052-3.258c-.187-1.851-.527-2.966-.455-2.985",
					transform: "translate(-29.728 -13.392)",
					fill: "#fff"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_8888",
					"data-name": "Path 8888",
					d: "M113.668,56.6a6.736,6.736,0,0,1,.1,1.858,19,19,0,0,1-2.4,8.594,6.659,6.659,0,0,1-1.045,1.538,15.492,15.492,0,0,1,.815-1.659,23.509,23.509,0,0,0,2.367-8.489,15.077,15.077,0,0,1,.161-1.842",
					transform: "translate(-32.4 -16.623)",
					fill: "#fff"
				})
			]
		})
	})]
});
export { SvgMotionWarning as ReactComponent };
